import { registerPlugin } from '@capacitor/core';
/**
 * @internal
 * @hidden
 */
export const ScanbotBarcodeSDKPlugin = registerPlugin('ScanbotBarcodeSDK', {});
//# sourceMappingURL=definitions.js.map